// import CustomizedRole from "../_pages/CustomizedRole";
import Index from "../_components/FAQs";
import AccountSettingsPage from "../_components/FAQs/ManagingAccountSetting";
import DashBoard from "../_components/Reporting/DashBoard";
import CompanyOverviewDetails from "../_components/Reporting/CompanyOverviewDetails";
import EscalaltionManagement from "../_components/EsclalationManagement/Index";
import TicketDetails from "../_components/EsclalationManagement/TicketDetails";
import ContentManagement from "../_components/CMS/ContentManagement";
import Management from "../_components/UserManagement/Management";
import RoleplayManagement from "../_components/RolePlayManagement/RolePlayManagement";
import EditScenario from "../_components/RolePlayManagement/EditScenario";
import AddCategories from "../_components/RolePlayManagement/AddCategories";
import CategoryAndSubCategory from "../_components/RolePlayManagement/CategoryAndSubCategories";
import ScenarioPreview from "../_components/RolePlayManagement/ScenarioPreview";
import NotificationPage from "../_pages/NotificationPage";
import DataAccessAndReportPage from "../_pages/DataAccessAndReportPage";
import UserManagementPage from "../_pages/UserManagementPage";
import SecurityAndCompliancesPage from "../_pages/SecurityAndCompliancePage";
import RoleManagementPage from "../_pages/RoleManagementPage";
// import AddScenario from "../_components/RolePlayManagement/AddScenario";
import ReadOnlyTutorialsViewPage from "../_pages/ReadOnlyTutorialsViewPage";
import OverviewDetails from "../_components/Reporting/OverViewDetails";
import AddRoleplayIndex from "../_components/RolePlayManagement/addRoleplay/AddRoleplayIndex"
const ProtectedRotues = [
  {
    path: "/",
    element: <UserManagementPage />,
  },
  {
    path: "faqs",
    element: <Index />,
  },
  {
    path: "reporting",
    element: <DashBoard />,
  },
  {
    path: "escalation",
    element: <EscalaltionManagement />,
  },
  {
    path: "escalation/ticketdetails",
    element: <TicketDetails />,
  },
  {
    path: "reporting/overviewDetails",
    element: <OverviewDetails />,
  },
  {
    path: "contentMangement",
    element: <ContentManagement />,
  },
  {
    path: "userManagement",
    element: <Management />,
  },
  {
    path: "roleplayManagement",
    element: <RoleplayManagement />,
  },
  {
    path: "/roleplayManagement/editscenario",
    element: <EditScenario />,
  },
  {
    path: "/roleplayManagement/addScenario",
    element: <AddRoleplayIndex />,
  },
  {
    path: "/roleplayManagement/addcategories",
    element: <AddCategories />,
  },
  {
    path: "/subcategories",
    element: <CategoryAndSubCategory />,
  },
  {
    path: "/scenarioPreview",
    element: <ScenarioPreview />,
  },
  {
    path: "/notificationManagement",
    element: <NotificationPage />,
  },
  {
    path: "/dataAccessReport",
    element: <DataAccessAndReportPage />,
  },
  {
    path: "securityAndCompliances",
    element: <SecurityAndCompliancesPage />,
  },
  {
    path: "readonlyview",
    element: <ReadOnlyTutorialsViewPage />,
  },
  {
    path: "roleManagement",
    element: <RoleManagementPage />,
  },
  {
    path: "/tutorials/manageAccountSetting",
    element: <AccountSettingsPage />,
  },
];

export default ProtectedRotues;
